import { Box } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import AllTenure from '../../component/AllTenure'

const TenuresExpired = () => {
  const [tData, setTData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      let response = await fetch('http://localhost:3000/tall');
      let data = await response.json();
      data = data.filter((d) => d.tenure_status === "Expired")
      setTData(data);
    }
    fetchData()
  }, [])
  return (
    <Box p={5} flex="1" w={'100%'}>
      <AllTenure
        title={"Expired Tenures"}
        head={["Tenure ID", "Order Item", "Total Rent", "Tenure Type", "Billing Date", "Expiry Dtae", "Payment Status", "Tenure Status", ""]}
        data={tData}
      />
    </Box>
  )
}

export default TenuresExpired
